export const handleUpdateNote = (
  values,
  onUpdateNote,
  dataComponentId,
  performUpdateRequest,
  setSnackMessage
) => {
  onUpdateNote(values, dataComponentId, performUpdateRequest, setSnackMessage);
};
